import { apiClient } from './client'
import type {
  ChatConversation,
  CreateChatConversationRequest,
  SendChatMessageRequest,
  SendChatMessageResponse,
} from '@/types'

export const chatApi = {
  listConversations: (familyId: string) =>
    apiClient.get<ChatConversation[]>(`/families/${familyId}/chat/conversations`),

  createConversation: (familyId: string, data: CreateChatConversationRequest = {}) =>
    apiClient.post<ChatConversation>(`/families/${familyId}/chat/conversations`, data),

  getConversation: (familyId: string, conversationId: string) =>
    apiClient.get<ChatConversation>(
      `/families/${familyId}/chat/conversations/${conversationId}`
    ),

  sendMessage: (familyId: string, conversationId: string, data: SendChatMessageRequest) =>
    apiClient.post<SendChatMessageResponse>(
      `/families/${familyId}/chat/conversations/${conversationId}/messages`,
      data
    ),
}
